import {useState, useRef} from 'react';
import {Row, Col, Form, Button} from 'react-bootstrap'
import { iminioBackend } from '../../api/iminio_provider';
import i18n from '../../plugins/i18n';

function CreateUserForm({ changeView }) {

    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const firstnameField = useRef(null);
    const lastnameField = useRef('');
    const emailField = useRef('');
    const passwordField = useRef('');
    const notesField = useRef('');
    const phoneField = useRef('');

    const validatePhone = (phone) => {
        phone = phone.replace('+','')
        phone = phone.replace(' ','')
        return !Number.isNaN(parseInt(phone))
    }

    const handleSubmit = async () => {
        setError("")
        setLoading(true)
        try{
            if(
                validatePhone(phoneField?.current?.value)===false
                || phoneField?.current?.value.includes('\'')
                || phoneField?.current?.value.includes('`')
                || phoneField?.current?.value.includes('"')
                || phoneField?.current?.value.includes('p')
                || phoneField?.current?.value.includes('d')
                || phoneField?.current?.value.includes('e')
                || phoneField?.current?.value.includes('f')
            ){
                throw new Error()
            }
        }catch(e){
            console.log(e)
            setTimeout(()=>{
                setLoading(false)
                setError('Telefono é compilato erroneamente.')
            },300)
            return
        }
        const newUserData = {
            first_name: firstnameField.current.value,
            last_name: lastnameField.current.value,
            email: emailField.current.value,
            password: passwordField.current.value,
            notes: notesField.current.value,
            phone: phoneField.current.value,
        }
        await iminioBackend.create_user(newUserData).then(()=>{
            changeView('user')
            setLoading(false)
        }).catch(e=>{
            switch(e.response?.data?.status?.code){
                case 'ERR_INVALID_FIELDS':
                    let details = e.response.data.details[0]
                    if(details.code==='string.empty')
                        setError(i18n.t('errors.required_field').replace('{1}', i18n.t(`models.user.fields.${details.field}`)))
                    else if(['number.base', 'string.pattern.base', 'date.base', 'any.base'].includes(details.code))
                        setError(i18n.t('errors.invalid_field').replace('{1}', i18n.t(`models.user.fields.${details.field}`)))
                    else
                        setError(i18n.t('errors.unknown'))
                    break;
                case 'ERR_ALREADY_EXISTS':
                    let details2 = e.response.data.details
                    setError(`${i18n.t(`models.user.fields.${details2.field}`)} ${details2.value} `+i18n.t('errors.already_in_use'))
                    break;
                default:
                    setError(i18n.t('errors.unknown'))
                    break;
            }
            setLoading(false)
        })
    }

    return <Col xs={12} className="mt-4">
        <Row>
            <Col xs={12} md={4} className='ps-3 d-flex justify-content-start align-items-center'>
                <i className="mdi mdi-account-plus text-20 fg-orange me-3"></i>
                <h3 className="">Creare Utente</h3>
            </Col>
        </Row>
        <div className="divider-h mt-2"></div>
        <Row className='p-4'>
            <Col xs={12} md={5} className="justify-content-center pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column xs="4" className="text-9">
                        Nome (*)
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type='text' ref={firstnameField}/>
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={12} md={5} className="justify-content-center pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label column xs="4" className="text-9">
                        Cognome (*)
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type='text' ref={lastnameField}/>
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={12} md={5} className="justify-content-center pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label column xs="4" className="text-9">
                        E-mail (*)
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type='text' ref={emailField}/>
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={12} md={5} className="justify-content-center pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label column xs="4" className="text-9">
                        Telefono (*)
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type='text' ref={phoneField}/>
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={12} md={5} className="justify-content-center pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label column xs="4" className="text-9">
                        Password (*)
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type='password' ref={passwordField}/>
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={12} md={5} className="justify-content-center pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column xs="3" className="text-9">
                        Note
                    </Form.Label>
                    <Col xs="9">
                        <Form.Control as="textarea" rows="5" type='text' ref={notesField}/>
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={12} className="d-flex justify-content-end align-items-center">
                {
                    !error || error.length===0 ? '' :
                    <span className="bg-red fg-white justify-content-center px-4 text-9 iminio-border-round-force me-3">
                        <i className="mdi mdi-alert-circle me-2"></i>
                        {error}
                    </span>
                }
                {
                    !isLoading ? '' :
                    <>
                        <span className='me-2'>Salvataggio in corso</span>
                        <i className="mdi mdi-loading mdi-spin text-15 me-2"></i>
                    </>   
                }
                <Button className={`px-5 corner-round bg-orange fg-white`} variant="orange" disabled={isLoading} onClick={()=>{handleSubmit()}}>
                    <i className="mdi mdi-content-save me-2"></i>
                    Salva
                </Button>
            </Col>
        </Row>
    </Col>;
}

export default CreateUserForm